import axios from "axios";
import {MASTER_OUTBOUND_LIST_URL, OUTBOUND_ITEM_DETAIL_LIST_URL} from '../config/links'
import {toast} from 'react-toastify'

export const FETCH_MASTER_OUTBOUND_LIST = 'FETCH_MASTER_OUTBOUND_LIST'
export const RECEIVE_MASTER_OUTBOUND_LIST = 'RECEIVE_MASTER_OUTBOUND_LIST'
export const FAILED_MASTER_OUTBOUND_LIST = 'FAILED_MASTER_OUTBOUND_LIST'

export function fetchMasterOutbound(auth, id){
    let _id_master_outbound = window.atob(id)
    return (dispatch, getState) => {
        dispatch({type: FETCH_MASTER_OUTBOUND_LIST});
        Promise.all([
            axios({
                method: 'post',
                url: MASTER_OUTBOUND_LIST_URL,
                headers: {
                    Authorization: auth
                },
                data:{
                    id: _id_master_outbound
                }
            }),
            axios({
                method: 'post',
                url: OUTBOUND_ITEM_DETAIL_LIST_URL,
                headers: {
                    Authorization: auth
                },
                data:{
                    id_master_outbound: _id_master_outbound
                }
            })
        ])
        .then((response) => {
            dispatch( {
                type: RECEIVE_MASTER_OUTBOUND_LIST,
                payloadOfMasterOutbound: response[0].data,
                payloadOfOutboundItem: response[1].data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_MASTER_OUTBOUND_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_MASTER_OUTBOUND_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_MASTER_OUTBOUND_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_MASTER_OUTBOUND_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_MASTER_OUTBOUND_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_MASTER_OUTBOUND_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/stck.masteroutboundwithItem.act.js